import React from "react";
import { Instagram, Globe } from "lucide-react";
import { EMAIL, INSTAGRAM, WEBSITE } from "../../data/content";
import { PineTree } from "./decor";

export default function Footer() {
  return (
    <footer className="relative overflow-hidden bg-forest px-5 py-12 text-kraft" data-testid="footer">
      <PineTree className="absolute -left-2 bottom-0 h-24 w-14 text-sage/20" />
      <PineTree className="absolute right-2 -top-2 h-20 w-12 text-sage/20" />
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 text-center">
        <img src="/logo-badge.png" alt="Karamiko" className="h-16 w-16" />
        <p className="max-w-md font-body text-sm text-kraft/80">
          Teatre artesanal, sostenible i feminista · en català · des de Lleida.
        </p>
        <div className="flex flex-col items-center gap-2">
          <a href={`mailto:${EMAIL}`} className="link-draw font-display font-semibold text-kraft" data-testid="footer-email">
            {EMAIL}
          </a>
          <a
            href={INSTAGRAM.url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 font-body text-sm text-kraft/80 link-draw"
            data-testid="footer-instagram"
          >
            <Instagram className="h-4 w-4" />
            {INSTAGRAM.handle}
          </a>
          <a
            href={WEBSITE.url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 font-body text-sm text-kraft/80 link-draw"
            data-testid="footer-website"
          >
            <Globe className="h-4 w-4" />
            {WEBSITE.label}
          </a>
        </div>
        <p className="mt-2 font-body text-xs text-kraft/50">
          © {new Date().getFullYear()} Karamiko · Companyia de teatre · Animal Soul
        </p>
      </div>
    </footer>
  );
}
